import { decode } from '../../server/lib/codec';
import {
  ResponseDeliveryInstructionsEligibility,
  ResponseDeliveryInstructionsEligibilityV,
  RequestDeliveryInstructionsEligibility,
  RequestDeliveryInstructionsAddressVerificationFields,
  ParamsDeliveryInstructions,
  ParamDeliveryManagementCarrier,
} from '../../server/api/schema';

interface EligibilityParams {
  carrier: string;
  trackingNumber: ParamsDeliveryInstructions['trackingNumber'];
  retailerMoniker: string;
  addressVerification?: RequestDeliveryInstructionsAddressVerificationFields;
}

const eligibility = async ({
  carrier,
  trackingNumber,
  retailerMoniker,
  addressVerification,
}: EligibilityParams): Promise<ResponseDeliveryInstructionsEligibility> => {
  if (!Object.values<string>(ParamDeliveryManagementCarrier).includes(carrier))
    throw new Error(`Unsuppported carrier ${carrier}`);

  const url = `/api/v1/delivery-management/${carrier}/delivery-instructions/${trackingNumber}/eligibility`;
  const body: RequestDeliveryInstructionsEligibility<null> = {
    addressVerification,
    retailerMoniker,
  };

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const eligibilityJson: unknown = await response.json();
  const decoded = decode(
    ResponseDeliveryInstructionsEligibilityV,
    eligibilityJson,
  );

  return decoded;
};

export type GetEligibilityParams = Omit<
  EligibilityParams,
  'addressVerification'
>;

export const getEligibility = ({
  carrier,
  trackingNumber,
  retailerMoniker,
}: GetEligibilityParams): Promise<ResponseDeliveryInstructionsEligibility> =>
  eligibility({ carrier, trackingNumber, retailerMoniker });

type VerifyAddressParams = Required<EligibilityParams>;

export const verifyAddress = ({
  carrier,
  trackingNumber,
  retailerMoniker,
  addressVerification,
}: VerifyAddressParams): Promise<ResponseDeliveryInstructionsEligibility> =>
  eligibility({
    carrier,
    trackingNumber,
    retailerMoniker,
    addressVerification,
  });
